import React from 'react';
import { Typography, Box } from '@mui/material';
import StyledFooterBox, {
  StyledColorBox,
} from 'views/rebranded-module/common/components/Logical/MainWidgetV2/components/PriceLegendFooter/PriceLegendFooter.styles';
import { useTranslation } from 'next-i18next';

interface PriceLegendFooterProps {
  low?: string;
  medium?: string;
  high?: string;
}

export const PriceLegendFooter: React.FC<PriceLegendFooterProps> = ({
  low,
  medium,
  high,
}) => {
  const { t } = useTranslation('common_rental_widget_v2');

  return (
    <StyledFooterBox>
      <Box className="LDBColorKeyContainer">
        {low && (
          <StyledColorBox variant="low">
            {t('common_rental_widget_v2:value_plus', { value: low })}
          </StyledColorBox>
        )}
        {medium && (
          <StyledColorBox variant="medium">
            {t('common_rental_widget_v2:value_plus', { value: medium })}
          </StyledColorBox>
        )}
        {high && (
          <StyledColorBox variant="high">
            {t('common_rental_widget_v2:value_plus', { value: high })}
          </StyledColorBox>
        )}
      </Box>
      <Typography variant="body2" className="LDBColorCaption">
        {t('common_rental_widget_v2:estimated_based_to_demand_availability')}
      </Typography>
    </StyledFooterBox>
  );
};
